import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import {
  format as dateFnsFormat,
  formatDistance,
  formatDistanceStrict,
  formatDistanceToNow,
  formatDistanceToNowStrict,
} from 'date-fns';
import React from 'react';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    root: {
      display: 'inline-block',
    },
  })
);

interface DateDisplayProps {
  date: string | Date | number;
  format?: string;
  distanceFormat?: 'default' | 'defaultStrict' | 'toNow' | 'toNowStrict';
  distanceOptions?: {
    addSuffix?: boolean;
    includeSeconds?: boolean;
  };
}

export default function DateDisplay({
  date,
  format = "YYYY'-'LL'-'dd' 'H-mm-ss",
  distanceFormat,
  distanceOptions,
}: DateDisplayProps) {
  const classes = useStyles();

  let dateToDisplay: string;

  let dateObj: Date;
  if (typeof date === 'string' || typeof date === 'number') {
    dateObj = new Date(date);
  } else {
    dateObj = date;
  }

  if (distanceFormat) {
    switch (distanceFormat) {
      case 'default':
        dateToDisplay = formatDistance(dateObj, new Date(), distanceOptions);
        break;
      case 'defaultStrict':
        dateToDisplay = formatDistanceStrict(
          dateObj,
          new Date(),
          distanceOptions
        );
        break;
      case 'toNow':
        dateToDisplay = formatDistanceToNow(dateObj, distanceOptions);
        break;
      case 'toNowStrict':
        dateToDisplay = formatDistanceToNowStrict(dateObj, distanceOptions);
        break;
    }
  } else {
    dateToDisplay = dateFnsFormat(dateObj, format);
  }

  return <div className={classes.root}>{dateToDisplay}</div>;
}
